export const drawerItemsMain = [
  {
    key: "CustomerOrderReport",
    title: "Customer Order Screen",
    routes: [
      {
        nav: "CustomerOrderReport",
        routeName: "CustomerOrderReport",
        title: "Customer Order Screen",
      },
    ],
  },
  {
    key: "KanbanPOCScreen",
    title: "Kanban POC",
    routes: [
      {
        nav: "KanbanPOCScreen",
        routeName: "KanbanPOCScreen",
        title: "Kanban POC Report",
      },
    ],
  },
  {
    key: "CustomerIssueReport",
    title: "Customer Issue Screen",
    routes: [
      {
        nav: "CustomerIssueReport",
        routeName: "CustomerIssueReport",
        title: "Customer Issue Report",
      },
    ],
  },
];
